<template>
  <div class="app-page">
    <Header />
    <div class="main-page-div">
      <main class="main-display-area">
        <AnnotationEditor v-bind="$attrs" />
      </main>
    </div>
  </div>
</template>

<script setup>
import Header from '@/components/Header.vue';
import AnnotationEditor from '@/components/DatasetComponent/AnnotationTool/AnnotationEditor.vue';
</script>
